/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CitationRevenueCollectedResponse } from '../models/CitationRevenueCollectedResponse'
import type { DashboardCitationCountResponse } from '../models/DashboardCitationCountResponse'
import type { DashboardShapeItem } from '../models/DashboardShapeItem'
import type { OccupancyByShapeItem } from '../models/OccupancyByShapeItem'
import type { OccupancyHoursEnum } from '../models/OccupancyHoursEnum'
import type { OccupancyMetricsEnum } from '../models/OccupancyMetricsEnum'
import type { Page_DashboardLayerItem_ } from '../models/Page_DashboardLayerItem_'
import type { ParkingDateRangeResponse } from '../models/ParkingDateRangeResponse'
import type { ParkingOperatorDataType } from '../models/ParkingOperatorDataType'
import type { ParkingSpacesResponse } from '../models/ParkingSpacesResponse'
import type { ParkingTotalSessionsResponse } from '../models/ParkingTotalSessionsResponse'
import type { RevenueCountResponse } from '../models/RevenueCountResponse'
import type { TimePeriodEnum } from '../models/TimePeriodEnum'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class CurbDashboardService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Dashboard Shapes
   * All shapes for the selected layer, ordered by display name.
   * Used to populate the shape multi-select filter in the dashboard header.
   * @returns DashboardShapeItem Successful Response
   * @throws ApiError
   */
  public getDashboardShapes({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<Array<DashboardShapeItem>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/shapes',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Parking Spaces Endpoint
   * Total parking spaces for the dashboard header card.
   * Space count is shape-filtered but not time-period-dependent.
   * @returns ParkingSpacesResponse Successful Response
   * @throws ApiError
   */
  public getDashboardParkingSpacesEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<ParkingSpacesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/statistics/parking/spaces',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Parking Total Sessions Endpoint
   * Total parking sessions for the dashboard stat card.
   * Session count is shape- and time-period-filtered.
   * Returns a compare value when compare dates are provided.
   * @returns ParkingTotalSessionsResponse Successful Response
   * @throws ApiError
   */
  public getDashboardParkingTotalSessionsEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<ParkingTotalSessionsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/statistics/parking/total_sessions',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Citation Revenue Collected Endpoint
   * Total citation payment revenue collected (in cents) for the dashboard stat card.
   * Returns a compare value when compare dates are provided.
   * Returns empty response when no payment data exists for this layer.
   * @returns CitationRevenueCollectedResponse Successful Response
   * @throws ApiError
   */
  public getDashboardCitationRevenueCollectedEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<CitationRevenueCollectedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/statistics/citations/revenue_collected',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Parking Revenue Counts Endpoint
   * Parking revenue time series for the dashboard stacked bar chart.
   * Returns source: Parking or Citations or Permits, for primary and, when requested, compare periods.
   * Returns empty list when no parking data exists for this layer.
   * @returns RevenueCountResponse Successful Response
   * @throws ApiError
   */
  public getDashboardParkingRevenueCountsEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    timePeriodType,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Group counts by: day | week | month | year
     */
    timePeriodType?: TimePeriodEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<RevenueCountResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/revenue/parking/aggregated_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        time_period_type: timePeriodType,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Citation Revenue Counts Endpoint
   * Citation revenue time-series for the dashboard stacked bar chart.
   * Counts are integer cents — the frontend is responsible for dividing by 100.
   * Returns empty list when no citation payment data exists for this layer.
   * @returns RevenueCountResponse Successful Response
   * @throws ApiError
   */
  public getDashboardCitationRevenueCountsEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    timePeriodType,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Group counts by: day | week | month | year
     */
    timePeriodType?: TimePeriodEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<RevenueCountResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/revenue/citations/aggregated_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        time_period_type: timePeriodType,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Citation Counts Endpoint
   * Citation issuance time series for the dashboard line chart.
   * Returns primary and, when requested, compare period entries.
   * Returns empty list when no citation issuance data exists for this layer.
   * @returns DashboardCitationCountResponse Successful Response
   * @throws ApiError
   */
  public getDashboardCitationCountsEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    timePeriodType,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Group counts by: day | week | month | year
     */
    timePeriodType?: TimePeriodEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<DashboardCitationCountResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/citations/aggregated_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        time_period_type: timePeriodType,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Vector
   * Vector tiles for the dashboard combined revenue choropleth map.
   * Merges parking and citation revenue per shape for the colour scale.
   * Either source returning no data degrades gracefully.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getDashboardVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Occupancy By Shape Endpoint
   * Shapes ranked by the selected metric (default average occupancy) for the
   * given data_type. The frontend fires this twice in parallel — once with
   * data_type=payments and once with data_type=sensors — and merges by
   * shape_uuid. limit is typically applied only on the payments call (the
   * ranking); the sensors call returns all shapes so the frontend can look up
   * the actual value for each paid row.
   * @returns OccupancyByShapeItem Successful Response
   * @throws ApiError
   */
  public getDashboardOccupancyByShapeEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    dataType,
    metric,
    hours,
    sort = 'desc',
    limit,
    startTime,
    endTime,
    daysOfWeek,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Metric used for ranking and returned values
     */
    metric?: OccupancyMetricsEnum | null
    /**
     * Enforced (meter-active) hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * desc = highest metric value first, asc = lowest first
     */
    sort?: 'asc' | 'desc'
    /**
     * Max shapes to return
     */
    limit?: number | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<OccupancyByShapeItem>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_dashboard/occupancy/by_shape',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        data_type: dataType,
        metric: metric,
        hours: hours,
        sort: sort,
        limit: limit,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Date Range
   * Union of min/max dates across all dashboard sources (parking + citation revenue + citation issuance).
   * @returns ParkingDateRangeResponse Successful Response
   * @throws ApiError
   */
  public getDashboardDateRange({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<ParkingDateRangeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_dashboard/date_range',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Dashboard Layers
   * Layers that have parking OR citation data for this region.
   * Region boundary is always first and marked is_default=True.
   * @returns Page_DashboardLayerItem_ Successful Response
   * @throws ApiError
   */
  public getDashboardLayers({
    regionId,
    page = 1,
    size = 50,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
  }): CancelablePromise<Page_DashboardLayerItem_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_dashboard/layers',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
